import React from "react";
import { node, string } from "prop-types";
import classNames from "classnames";

const GridTableHeader = ({ children, className, ...props }) => (
    <div className={classNames("grid-table-header", className)} {...props}>
        {children}
    </div>
);

GridTableHeader.propTypes = {
    children: node.isRequired,
    className: string,
};

GridTableHeader.defaultProps = {
    className: "",
};

export default GridTableHeader;
